










import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import UploadButton from '@/shared/UploadButton.vue';
import Companies from '@/features/companies/components/index.vue';
import Stores from '@/features/stores/components/Stores.vue';

@Component({
  name: 'dashboard',
  components: {
    UploadButton,
    Companies,
    Stores,
  },
})
export default class Dashboard extends Vue {}
